/**
 * @file index.tsx
 *
 * @fileoverview Skip to main content navigation.
 */

import { Root as VisuallyHidden } from "@radix-ui/react-visually-hidden";
import * as React from "react";

export interface HiddenVisuallyProps {
  /**
   * The contents for what is visually hidden.
   */
  children: React.ReactNode;
  /**
   * Optional id.
   */
  id?: string;
}

/**
 * Provides text for screen readers that is visually hidden.
 * It is the logical opposite of the aria-hidden attribute.
 */
export const HiddenVisually = ({ children, ...props }: HiddenVisuallyProps) => {
  return <VisuallyHidden {...props}>{children}</VisuallyHidden>;
};
export default HiddenVisually;
